import styled from 'styled-components'
import { colors, media } from 'client/styles'
import { ButtonPrimary } from 'src/comps/Button/styles'
import { InputWrapper } from 'client/components/InputLine/styles'

export const VerifyEmailBase = styled.form`
  background-color: ${colors.white};
  width: 100%;
  padding-block: 0 10px;
  padding-inline: 20px;
  border-radius: 8px;
`

export const Row = styled.div`
  margin-block-end: 20px;
`

export const Title = styled(Row)`
  display: flex;
  font-weight: 700;
  font-size: 21px;
  line-height: 100%;

  color: ${colors.grey1};
  margin-block-end: 12px;
`

export const SubTitle = styled(Row)`
  display: flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;

  color: ${colors.grey2};
  padding-block-end: 8px;
`

export const ButtonContainer = styled(Row)`
  display: flex;
  width: 100%;
  padding-block: 0;
  padding-inline: 0;

  ${media.tablet} {
    width: auto;
    margin-block-start: 3px;
  }
`

export const ButtonSubscribe = styled(ButtonPrimary)`
  min-width: 177px;
  width: 100%;
  height: 48px;
  font-size: 16px;

  ${media.tablet} {
    flex: 0 0 auto;
    font-size: 16px;
    padding-block: 12px;
    padding-inline: 22px;
  }
`

export const InputSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  ${InputWrapper} {
    width: 100%;
  }
`

export const WrapperInput = styled(Row)`
  width: 100%;
  display: flex;
  flex-direction: column;
`
